'use strict'

import './ProductServiceCard.css'

import React from 'react'
import InfoIcon from './images/info-new.svg'

function ProductServiceCard (props) {
  /**
   * Показ описания
   *
   * @param event
   */
  function showPreview (event) {
    event.preventDefault()
    event.stopPropagation()
    // формируем и показываем окно с описанием
    import(/* webpackPreload: true */ '../../popup')
      .then(module => {
        let popup = new module.Popup('additional-services', false)
        // Устанавливаем тело окна
        popup.body =
          `<div class="additional-services-popup-title">${props.NAME}</div>` +
          `<div class="additional-services-popup-body">${props['~PREVIEW_TEXT']}</div>`
        popup.open()
      })
  }

  const active = ((props.hasOwnProperty('ACTIVE') && (props['ACTIVE'] === true)))

  return (
    <div className="additional-services-item">
      <input type="checkbox"
             id={`service-${props.ID}`}
             value={props.ID}
             onChange={props.onCheckService}
             checked={active}/>
      <label htmlFor={`service-${props.ID}`}>
        <div className="additional-services-item-text">
          <div className="additional-services-item-title"><span>{props.NAME}</span></div>
        </div>
      </label>
      <span className="open-services-modal">
        <img src={InfoIcon}
             width={`14px`}
             height={`14px`}
             title={`info`}
             onClick={showPreview}
        />
      </span>
      <div className="additional-services-item-price">{props.PRICE['PRINT_PRICE']}</div>
    </div>
  )
}

export default ProductServiceCard